import { TableHeaderData } from "@forge/common";
export const GET_VPP_TEMPLATES = "GET_VPP_TEMPLATES";
export const GET_OS_LIST = "GET_OS_LIST";
export const SET_OS_LIST = "SET_OS_LIST";
export const GET_OS_VERSIONS = "GET_OS_VERSIONS";
export const SET_OS_VERSIONS = "SET_OS_VERSIONS";
export const SET_VPP_TEMPLATES = "SET_VPP_TEMPLATES";
export const GET_NIC_NETWORK = "GET_NIC_NETWORK";
export const SET_NIC_NETWORK = "SET_NIC_NETWORK";
export const GET_ALL_VAPP_TEMPLATES_AND_VMS = "GET_ALL_VAPP_TEMPLATES_AND_VMS";
export const SET_ALL_VAPP_TEMPLATES_AND_VMS = "SET_ALL_VAPP_TEMPLATES_AND_VMS";
export const GET_VM_DETAILS = "GET_VM_DETAILS";
export const SET_VM_DETAILS = "SET_VM_DETAILS";
export const GET_TEMPLATES = "GET_TEMPLATES";
export const SET_TEMPLATES = "SET_TEMPLATES";
export const GET_NIC_NETWORK_ADAPTER_TYPES = "GET_NIC_NETWORK_ADAPTER_TYPES";
export const SET_NIC_NETWORK_ADAPTER_TYPES = "SET_NIC_NETWORK_ADAPTER_TYPES";
export const SET_NIC_IP_MODES = "SET_NIC_IP_MODES";
export const GET_NIC_IP_MODES = "GET_NIC_IP_MODES";
export const GET_VPP_TEMPLATES_ERROR = "GET_VPP_TEMPLATES_ERROR";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const PUBLISH_COURSE_DEFINITION = "PUBLISH_COURSE_DEFINITION";
export const PUBLISH_COURSE_DEFINITION_SUCCESS = "PUBLISH_COURSE_DEFINITION_SUCCESS";
export const PUBLISH_COURSE_DEFINITION_FAILURE = "PUBLISH_COURSE_DEFINITION_FAILURE";
export const SAVE_UPDATE_COURSE_DEFINITION = "SAVE_UPDATE_COURSE_DEFINITION";
export const SAVE_UPDATE_COURSE_DEF_SUCCESS = "SAVE_UPDATE_COURSE_DEF_SUCCESS";
export const SAVE_UPDATE_COURSE_DEF_ERROR = "SAVE_UPDATE_COURSE_DEF_ERROR";
export const RESET_COURSE_CREATION_STATE = "RESET_COURSE_CREATION_STATE";
export const GET_COURSE_DATA_BY_ID = "GET_COURSE_DATA_BY_ID";
export const GET_COURSE_DATA_BY_ID_SUCCESS = "GET_COURSE_DATA_BY_ID_SUCCESS";
export const GET_COURSE_DATA_BY_ID_FAILURE = "GET_COURSE_DATA_BY_ID_FAILURE";
export const LIBRARY_ROUTES = {
    VIEW_COURSE_TEMPLATES: "viewCourseTemplates",
    CREATE_COURSE: "createCourse",
    COPY_COURSE: "copycourse",
    EDIT_COURSE: "editCourse",
    VIEW_COURSE: "viewCourse",
    START_COURSE_INSTANCE: "startCourseInstance",
    EDIT_COURSE_INSTANCE: "editCourseInstance",
    VIEW_DEPLOYED_COURSE_INSTANCE: "viewDeployedCourseInstance"
}
export const CREATE_COURSE_CONSTANTS = {
    PAGE_TITLE_CREATE: "Create Environment",
    PAGE_TITLE_EDIT: "Edit Course Environment",
    PAGE_TITLE_COPY: "Duplicating",
    BACK_LINK_TEXT: "Back to Library Management",
    BACK_LINK_URL: "/academy/viewCourseTemplates",
    TOAST_MSGS: {
        CREATE_COURSE_SUCCESS: 'Success',
        UPDATE_COURSE_SUCCESS: 'Success',
        PUBLISH_COURSE_SUCCESS: 'Success',
        CREATE_COURSE_FAILURE: 'Failed to create course',
        UPDATE_COURSE_FAILURE: 'Failed to update course',
        PUBLISH_COURSE_FAILURE: 'Failed to publish course'
    },
    VALIDATION_MESSAGES: {
        RAM_MAX_GB: 128,
        RAM_MAX_MB: 131072,
        RAM_MAX_128GB: 'RAM cannot exceed 128 GB',
        RAM_MAX_131072MB: 'RAM cannot exceed 131072 MB',
        COURSE_NAME_LENGTH: "Course name cannot exceed 30 characters",
        COURSE_NAME_INVALID_CHARS: "Course name must start with a letter and can contain letters, numbers, and underscores",
        TEMP_NAME: "Template name cannot exceed 50 characters",
        TEMP_INVALID: "Template name cannot contain HTML tags or script tags",
        TEMP_INVALID_CHARACTERS: "Template name can only contain letters, numbers, spaces, hyphens, dots, commas, and underscores",
        NETWORK_REQUIRED: "Network is required",
        NETWORK_ADAPTER_TYPE_REQUIRED: "Network adapter type is required",
        IP_MODE_REQUIRED: "IP mode is required",
        IP_ADDRESS_REQUIRED: "IP address is required",
        INVALID_IP1: "Invalid IP address format. Use xxx.xxx.xxx.xxx",
        INVALID_IP2: "Cannot use 0.0.0.0 as an IP address",
        INVALID_IP3: "Cannot use 255.255.255.255 as an IP address",
        COURSE_DURATION_REQUIRED: "Course duration is required",
        COURSE_DURATION_NUMERIC: "Course duration should be numeric",
        COURSE_DURATION_WHOLE_NUM: "Course duration must be a whole number",
        COURSE_DURATION_MIN: "Course duration must be at least 1 day",
        COURSE_DURATION_MAX: "Course duration cannot exceed 30 days",
        COURSENAME_REQUIRED: "Course name is required",
        TEMPLATE_REQUIRED: "vApp Template is required",
        TEMPLATE_NAME_REQUIRED: "vApp template name is required",
        MIN_ONE_VM: "At least one VM must be selected",
        MIN_ONE_NIC: "At least one NIC must be configured",
        VM_NAME_REQUIRED: "VM Name is required",
        CPU_REQUIRED: "CPU is required",
        RAM_REQUIRED: "RAM is required",
        STORAGE_REQUIRED: "Storage is required",
        STORAGE_ONLY_NUMBER: "Storage must be a whole number",
        STORAGE_GREATERTHAN_ZERO: "Storage must be greater than 0",
        STORAGE_CANNOT_REDUCE: "Storage cannot be reduced from the original value",
        STORAGE_MAX_1TB: "Storage cannot exceed 1 TB",
        OS_TYPE_REQUIRED: "OS type is required",
        OS_VERSION_REQUIRED: "OS version is required",
        BOOT_IMAGE_REQUIRED: "Boot image is required",
        LONG_INPUT: "Input is too long",
        VM_NAME_LENGTH: "VM Name cannot exceed 15 characters",
        NO_UNDERSCORE: "VM Name cannot contain underscores",
        ONLY_DIGITS: "VM Name cannot consist only of digits",
        ONLY_LETTERS: "VM Name can only contain letters, numbers and hyphens",
        NO_HYPHEN: "VM Name cannot end with a hyphen",
        ONLY_NUMBER: "RAM must be a whole number",
        GREATERTHAN_ZERO: "RAM must be greater than 0",
        MUST_MULTIPLE_OF_FOUR: "RAM must be a multiple of 4",
        ATLEAST_ONE_NIC_REQUIRED: "At least one NIC must be configured",
        ONE_PRIMARY_NIC: "At least one NIC must be marked as primary for new template",
        VALID_IP_ADDRESS: "Primary NIC should have valid static IP Address",
        NON_PRIMARY_NIC_DHCP: "Non-primary NICs must use DHCP mode"
    },
    GENERAL_DETAILS: {
        TITLE: "General Details",
        COURSE_NAME: {
            LABEL: "Course Name",
            PLACEHOLDER: "Course Name",
            ERROR: "Course name cannot exceed 50 characters"
        },
        DESCRIPTION: {
            LABEL: "Description",
            PLACEHOLDER: "Description",
            ERROR: "Description cannot exceed 250 characters",
            ELEMENT_ERROR: "Description cannot contain HTML tags or script tags",
            INVALID_CHARACTERS: "Description can only contain letters, numbers, spaces, hyphens, dots, commas, and underscores"
        },
        COURSE_DURATION: {
            LABEL: "Course Duration (Days)",
            PLACEHOLDER: "Duration",
            ERRORS: {
                REQUIRED: "Course duration is required",
                NUMERIC: "Course duration must be a whole number",
                MIN: "Course duration must be at least 1 day",
                MAX: "Course duration cannot exceed 30 days"
            }
        }
    },
    VAPP_TEMPLATE_DETAILS: {
        TITLE: "vApp Template Details",
        resultsRange: (from: number, to: number, total: number) => `${from}-${to} of ${total}`,
        TEMPLATE_ASSOCIATION: {
            LABEL: "How would you like to associate templates ?",
            OPTIONS: {
                EXISTING: "Select from existing templates",
                NEW: "Create New vApp Template"
            }
        },
        EXISTING_TEMPLATE: {
            LABEL: "Associate from Existing vApp Template",
            PLACEHOLDER: "Select",
            SEARCH_LABEL: "Search",
            SEARCH_PLACEHOLDER: "Search"
        },
        TEMPLATE_NAME: {
            LABEL: "vApp Template Name",
            PLACEHOLDER: "Template Name"
        },
        FILTER: {
            LABEL: "Filter",
            OPTIONS: {
                TEMPLATE_NAME: "Name",
                OS_TYPE: "OS Type",
            }
        },
        SEARCH: {
            PLACEHOLDER: "Search"
        },
        CREATE_VM_BUTTON: "Create New VM"
    },

    TABLE_HEADERS: {
        NAME: "NAME",
        OS_TYPE: "OS TYPE",
        OS_VERSION: "OS VERSION",
        RAM: "RAM",
        CPU: "CPU",
        IP_ADDRESS: "IP ADDRESS",
        STORAGE: "STORAGE"
    },
    LIST_VM_LABEL: "List of VM(s)",
    // Bottom Buttons
    BUTTONS: {
        CANCEL: "Cancel",
        CONTINUE: "Continue",
        SAVE_BTN: "Save Course Environment",
        UPDATE_BTN: "Update Course Environment",
        COPY_BTN: "Save Duplicate",
        PUBLISH: "Publish",
        CREATE_VM: "Create New VM",
        ADD_VM: "Add New VM",
        ADD_NIC: "Add NIC",
        ADD: "Add",
        SAVE: "Save"
    },
    MAX_VMS_OPENED: "You can open a maximum of 10 nodes at a time. Please close one to open another.",
    // Create New VM Modal
    CREATE_VM_MODAL: {
        CREATE_TITLE: "Create New VM",
        UPDATE_TITLE: "Update VM",
        POWER_ON: "Power On",
        POWER_OFF: "Power Off",
        STATE: "State",
        CONNECTED: "Connected",
        DISCONNECTED: "Not Connected",
        ALLOW_AUTO_PAUSE: "Allow auto pause the virtual machine",
        BOOT_IMAGE: "Boot Image",
        BOOT_SETUP: "Enter Boot Setup",
        CREATION_TYPE: {
            LABEL: "How would you like to create Virtual Machine ?",
            OPTIONS: {
                NEW_VM: "New Virtual Machine",
                FROM_TEMPLATE: "From Template"
            }
        },
        VM_NAME: {
            LABEL: "VM Name",
            PLACEHOLDER: "VM Name"
        },
        DESCRIPTION: {
            LABEL: "Description",
            PLACEHOLDER: "Description"
        },
        CPU: {
            LABEL: "CPU (Cores)",
            PLACEHOLDER: "cpu"
        },
        RAM: {
            LABEL: "RAM",
            PLACEHOLDER: "Enter RAM"
        },
        STORAGE: {
            LABEL: "Storage (GB)",
            PLACEHOLDER: "Enter Storage"
        },
        OS_TYPE: {
            LABEL: "OS Type",
            PLACEHOLDER: "Os Type"
        },
        OS_VERSION: {
            LABEL: "OS Version",
            PLACEHOLDER: "Os Version"
        },
        NIC_CONFIG: {
            TABLE_TITLE: "NIC Configuration",
            ADD_TITLE: "Add New NIC",
            ADD_BUTTON: "Add NIC",
            NETWORK: "Network",
            NW_ADAPTER_TYPE: "Network Adapter Type",
            IP_MODE: "IP Mode",
            IP_ADDRESS: "IP Address",
            IP_TYPE: "IP Type",
            MAC_ADDRESS: "Mac Address",
            MARK_PRIMARY: "Mark as Primary",
            NOT_FOUND: "No data found",
            TABLE_HEADERS: {
                ID: "ID",
                STATE: "STATE",
                MAC_ADDRESS: "MAC ADDRESS",
                NETWORK: "NETWORK",
                NETWORK_ADAPTER_TYPE: "NETWORK ADAPTER TYPE",
                IP_MODE: "IP MODE",
                PRIMARY: "MARK AS PRIMARY",
                ACTIONS: "ACTIONS"
            }
        },
        BUTTONS: {
            CANCEL: "Cancel",
            SAVE: "Save"
        }
    },

    CANCEL_VM_MODAL: {
        CREATE_TOAST: "Course template creation Cancelled",
        UPDATE_TOAST: "Course template updation Cancelled",
        SUBTOAST: "No data saved",
        CREATE_TITLE: "Cancel Course Environment Creation",
        UPDATE_TITLE: "Cancel Course Environment Updation",
        MESSAGE: "All unsaved changes will be lost. Do you want to continue ?",
        BUTTONS: {
            NO: "NO",
            YES: "Yes"
        }
    },
    PUBLISH_VALIDATION_TOAST: {
        TITLE: 'Cannot Publish Course',
        SUB_TITLE: 'One or more VMs are powered on. Please power off all VMs before publishing the course'
    },
    UPDATECOURSE_VALIDATION: {
        TITLE: 'Cannot Update Course',
    },
    DUPLICATE_IP: {
        ONE_IP: 'Duplicate IP address detected:',
        MORE_THAN: 'Duplicate IP addresses detected:'
    },
    PUBLISH_VALIDATION_MODAL: {
        TITLE: 'You have unsaved changes in the course. The updated course cannot be published with unsaved modifications.',
        LIST1: "Publish the course without your latest changes",
        LIST2: "Return to editing",
        BUTTONS: {
            CANCEL: "Cancel",
            DISCARD_CHANGES_AND_PUBLISH: "Discard Changes and Publish"
        }
    }
};

export const VMTableHeader = {
    NAME: "NAME",
    OSTYPE: "OS TYPE",
    OSVERSION: "OS VERSION",
    RAM: "RAM",
    CPU: "CPU",
    IPADDRESS: "IP ADDRESS",
    STORAGE: "STORAGE",
    VMPAUSABLE: "VM PAUSABLE",
    ACTIONS: "ACTIONS"
}

export const initialTableHeaderData: TableHeaderData[] = [
    {
        id: 'id',
        content: 'ID',
        className: 'nic-table-header !w-[60px] !min-w-[60px] !max-w-[60px]',
        canSort: false,
        canResize: false
    },
    {
        id: 'state',
        content: 'STATE',
        className: 'nic-table-header !w-[83px] !min-w-[83px] !max-w-[83px]',
        canSort: false,
        canResize: false
    },
    {
        id: 'macAddress',
        content: 'MAC ADDRESS',
        className: 'nic-table-header !w-[120px] !min-w-[120px] !max-w-[120px]',
        canSort: false,
        canResize: false
    },
    {
        id: 'network',
        content: 'NETWORK',
        className: 'nic-table-header !w-[125px] !min-w-[125px] !max-w-[125px]',
        canSort: false,
        canResize: false
    },
    {
        id: 'networkType',
        content: 'NETWORK ADAPTER TYPE',
        className: 'nic-table-header !w-[155px] !min-w-[155px] !max-w-[155px]',
        canSort: false,
        canResize: false
    },
    {
        id: 'ipMode',
        content: 'IP MODE',
        className: 'nic-table-header !w-[100px] !min-w-[100px] !max-w-[100px]',
        canSort: false,
        canResize: false
    },
    {
        id: 'ipType',
        content: 'IP TYPE',
        className: 'nic-table-header !w-[80px] !min-w-[80px] !max-w-[80px]',
        canSort: false,
        canResize: false
    },
    {
        id: 'ipAddress',
        content: 'IP ADDRESS',
        className: 'nic-table-header !w-[120px] !min-w-[120px] !max-w-[120px]',
        canSort: false,
        canResize: false
    },
    {
        id: 'isPrimary',
        content: 'PRIMARY',
        className: 'nic-table-header !w-[90px] !min-w-[90px] !max-w-[90px]',
        canSort: false,
        canResize: false
    },
    {
        id: 'actions',
        content: 'Actions',
        className: 'nic-table-header !w-[80px] !min-w-[80px] !max-w-[80px]',
        canSort: false,
        canResize: false
    }

];